import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Card, PageHeader, Row, Col, Button } from 'antd'
import Filters, { FilterItem, Types } from '../../components/Filters'
import AdminUserList from '../../components/AdminUserList'
import { AdminUserForm } from '../../components/Forms'
import { AdminUserProvider, AdminUserConsumer } from '../../context/AdminUserContext'
import { AdminRoleProvider, AdminRoleConsumer } from '../../context/AdminRoleContext'

export default class AdminUser extends Component {

  private adminUserFilterDispatchOptions = {
    search: {
      roles: {
        with: true
      }
    },
    options: {
      sort: []
    }
  } as const

  adminUserListSearch = {
    search: {
      roles: {
        with: true
      }
    }
  }

  handleFiltersSubmit = (payload: any) => {
    if (payload && payload.search) {
      this.adminUserListSearch.search = payload.search
    }
  }

  renderAdd = () => {
    const { permissions }: any = this.props
    if (!permissions.create) return null

    return (
      <Link to="user/add">
        <Button type="primary" shape="round">
          Create new user
        </Button>
      </Link>
    )
  }

  render() {
    const { permissions, history, match: { params: { userUuid } } }: any = this.props

    return (
      <AdminUserProvider>
        <AdminRoleProvider>
          <AdminRoleConsumer>
            {({ fetching: fetchingRole, roles, requestAdminRoleList }) => (
              <AdminUserConsumer>
                {({ fetching, error, users, user, pagination, requestAdminUserList, requestAdminUserFind, requestAdminUserCreate, requestAdminUserUpdate, requestAdminUserDelete, requestAdminUserResetPassword }) => {

                  // Edit user
                  if (userUuid) {
                    let addon: any = {
                      data: user,
                      permissions: permissions
                    }
                    if (userUuid !== 'add') {
                      addon = {
                        ...addon,
                        uuid: userUuid
                      }
                    }

                    return (
                      <Card>
                        <PageHeader title={userUuid === 'add' ? 'New User' : 'Edit User'} onBack={() => history.replace('/admin/user')}>
                          <AdminUserForm
                            {...addon}
                            roles={roles}

                            loading={fetching}
                            contentLoading={fetchingRole}
                            error={error}
                            history={history}

                            loadAdminUser={requestAdminUserFind}
                            loadAdminRoles={requestAdminRoleList}

                            dispatchCreate={requestAdminUserCreate}
                            dispatchUpdate={requestAdminUserUpdate}
                          />
                        </PageHeader>
                      </Card>
                    )
                  }

                  return (
                    <>
                      <Card title="Filters" style={{marginBottom: 25}}>
                        <Filters size="medium" loading={fetching} history={history} defaultSubmitOptions={this.adminUserFilterDispatchOptions} submitDispatch={requestAdminUserList} onSubmit={this.handleFiltersSubmit}>
                          {({ values, handleFilterChange }: any) => (
                            <Row gutter={9} style={{width: '100%'}}>
                              <Col xs={24} md={12}>
                                <FilterItem
                                  name={"or.first_name.ilike,or.last_name.ilike"}
                                  type={Types.INPUT}
                                  placeholder="Filter by Name"
                                  value={values["or.first_name.ilike,or.last_name.ilike"] }
                                  size="medium"
                                  options={{
                                    input: {  
                                      allowClear: true  
                                    }
                                  }}  
                                  onChange={handleFilterChange}
                                />
                              </Col>

                              <Col xs={24} md={12}>
                                <FilterItem
                                  name="email.ilike"
                                  type={Types.INPUT}
                                  placeholder="Filter by Email"
                                  value={values['email.ilike']}
                                  size="medium"
                                  options={{
                                    input: {
                                      allowClear: true
                                    }
                                  }}
                                  onChange={handleFilterChange}
                                />
                              </Col>
                            </Row>
                          )}
                        </Filters>
                      </Card>

                      <Card title="List of Users" extra={this.renderAdd()}>
                        <AdminUserList
                          loading={fetching}
                          users={users}
                          pagination={pagination}
                          permissions={permissions}
                          history={history}
                          searchOptions={this.adminUserListSearch}
                          loadAdminUsers={requestAdminUserList}
                          adminUserDelete={requestAdminUserDelete}
                          adminUserResetPassword={requestAdminUserResetPassword}
                        />
                      </Card>
                    </>
                  )
                }}
              </AdminUserConsumer>
            )}
          </AdminRoleConsumer>
        </AdminRoleProvider>
      </AdminUserProvider>
    )
  }
}
